/**
 * These utilities are to help keep colors consistent across the app. Normally, you'd probably
 * want to just create enums in the database to represent these colors. But Colors/styling is
 * very subjective and I wanted to leave the door open to easily allow customizations in the
 * future. So the database simply holds the hex value, and we use this code to limit what
 * they can choose in the UI
 */
/**
 * Curated color list for backgrounds on things such as phases and tags
 * Note: These colors come from the design system. They are the 100 level accent colors.
 * https://www.figma.com/design/eTknS5pZeNyGAD8dma1EZl/The-System?node-id=5478-193660&t=W7MrJtoh8pmosKr4-0
 */
export const BackgroundColors = [
    '#F670C7', // pink
    '#A48AFB', // violet
    '#528BFF', // blue_dark
    '#8098F9', // indigo
    '#717BBC', // grey_blue
    '#F38744', // orange_dark
    '#85E13A', // green_light
    '#3CCB7F', // green
    '#FAC515', // yellow
];
export const BackgroundColorNameKeys = {
    '#F670C7': 'colorPink',
    '#A48AFB': 'colorViolet',
    '#528BFF': 'colorBlue',
    '#8098F9': 'colorIndigo',
    '#717BBC': 'colorGreyBlue',
    '#F38744': 'colorOrange',
    '#85E13A': 'colorLightGreen',
    '#3CCB7F': 'colorGreen',
    '#FAC515': 'colorYellow',
};
/**
 * Curated color list for text on things such as phases and tags
 * Note: These colors are derived from the BackgroundColors by darkening them by 50%
 */
export const FontColors = [
    '#7B3864', // pink
    '#52457E', // violet
    '#294680', // blue_dark
    '#404C7D', // indigo
    '#393E5E', // grey_blue
    '#7A4422', // orange_dark
    '#43711D', // green_light
    '#1E6640', // green
    '#7D630B', // yellow
];
/**
 * Get an appropriate font color given the background color.
 * Throws an error for invalid background colors.
 */
export function getFontColor(bg) {
    return getComplimentaryColor(bg, BackgroundColors, FontColors);
}
/**
 * Get an appropriate background color given the font color.
 * Throws an error for invalid font colors.
 */
export function getBackgroundColor(fg) {
    return getComplimentaryColor(fg, FontColors, BackgroundColors);
}
function getComplimentaryColor(color, fromList, toList) {
    const index = fromList.indexOf(color);
    if (index < 0) {
        throw new Error(`Invalid color ${color}`);
    }
    const result = toList[index];
    if (!result) {
        throw new Error(`Invalid color ${color}`);
    }
    return result;
}
// For now color is hardcoded to the exercise type
export const getTagColorForType = (type) => {
    switch (type) {
        case 'exercise':
            return '#d3f8df';
        case 'workout_template':
            return '#fdf7c3';
        default:
            return '#eaecf5';
    }
};
//# sourceMappingURL=colors.js.map